import { formatPrice } from "@/utils/money";
import { pluralCount } from "@/utils/text";
import type { SalonStockerHttpTypes } from "@repo/api-sdk";
import { cn } from "@repo/design-system/utils";
import { memo } from "react";

export interface CartSummaryStatsProps {
  /**
   * Cart summary containing counts and totals
   */
  summary: SalonStockerHttpTypes.StoreSellerCartsResponse["summary"];
  /**
   * Additional CSS classes
   */
  className?: string;
}

/**
 * Displays cart summary statistics: product count, total, supplier count.
 * Used in the cart sidebar header.
 */
export const CartSummaryStats = memo(function CartSummaryStats({
  summary,
  className
}: CartSummaryStatsProps) {
  // Format total as currency
  const formattedTotal = formatPrice(summary.grand_total);

  return (
    <div className={cn("space-y-1", className)}>
      <div className="flex items-baseline justify-between">
        <span className="text-sm font-medium text-gray-600">
          {pluralCount(summary.total_items, "Product")}
        </span>
        <span className="text-lg font-semibold text-gray-900">
          {formattedTotal}
        </span>
      </div>
      <div className="text-xs text-gray-500">
        {pluralCount(summary.total_sellers, "Seller")}
      </div>
    </div>
  );
});
